var map = {
	"./armadillo.svg": 181,
	"./bat.svg": 353,
	"./coral.svg": 919,
	"./crocodile.svg": 392,
	"./crow.svg": 205,
	"./dolphin.svg": 252,
	"./donkey.svg": 364,
	"./elephant.svg": 999,
	"./frog.svg": 114,
	"./hedgehog.svg": 607,
	"./jellyfish.svg": 430,
	"./kiwi.svg": 908,
	"./koala.svg": 558,
	"./lion.svg": 270,
	"./mole.svg": 745,
	"./monkey.svg": 843,
	"./octopus.svg": 419,
	"./ostrich.svg": 568,
	"./owl.svg": 626,
	"./panda.svg": 120,
	"./parrot.svg": 960,
	"./pig.svg": 28,
	"./puffer.svg": 548,
	"./rabbit.svg": 480,
	"./rat.svg": 921,
	"./scorpion.svg": 891,
	"./sheep.svg": 533,
	"./skunk.svg": 134,
	"./snail.svg": 571,
	"./snake.svg": 992,
	"./whale.svg": 895,
	"./wolf.svg": 440,
	"./zebra.svg": 11
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;